/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Delivery_Sla_BreachInputs */

const vi_report_delivery_sla_breach = /** @type {(inputs: Report_Delivery_Sla_BreachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi phạm SLA`)
};

/**

* @param {Report_Delivery_Sla_BreachInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_delivery_sla_breach = /** @type {((inputs?: Report_Delivery_Sla_BreachInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Delivery_Sla_BreachInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_delivery_sla_breach(inputs)
});